import React from 'react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';

import Select from './Select';

const SelectField = props => (
  <div className={props.wrapperClass}>
    <div className="c-label-new">{props.label}</div>
    <Field {...props} component={Select} />
  </div>
);

SelectField.propTypes = {
  label: PropTypes.string,
  wrapperClass: PropTypes.string,
};

SelectField.defaultProps = {
  label: 'Select field',
  wrapperClass: 'layout__item u-1/2-medium-and-up',
};


export default SelectField;
